import React, { useEffect } from 'react'
import { RouteComponentProps } from '@reach/router'
import { PanelContent } from '../../../components/panel-content'
import { useStateValue } from '../../../components/state'
import { Button } from '../../../components/button'
import { useDelayedBoolean } from '../../../hooks/use-delayed-boolean'
import { MapFact } from '../../../components/map-fact'

export const RecycledIndustry: React.FC<RouteComponentProps> = () => {
  const [, dispatch] = useStateValue()

  // Filter map pins to desalination
  useEffect(() => {
    dispatch({
      type: 'setActiveMarkerType',
      payload: { activeMarkerType: 'wastewater-treatment' }
    })
  }, [dispatch])

  const factVisible = useDelayedBoolean({ delay: 500 })

  return (
    <PanelContent>
      <h1>Water recycling for industry use</h1>
      <p>
        The Kwinana Water Recycling Plant (KWRP) is our largest industrial water
        recycling plant. The plant provides wastewater treated to
        ‘fit-for-purpose’ standards for industrial use. Before the plant was
        built, industries in the Kwinana Industrial Area were using water from
        groundwater sources.
      </p>
      <p>
        The plant has saved a huge amount of water from our precious groundwater
        sources and even won an AWA Environment Award for its environmental
        benefits.
      </p>
      <MapFact
        aboveValue='Recycled water supplied by the KWRP has reduced drinking water use in the Kwinana Industrial Area by 4.6 billion litres. That’s the equivalent of 2,044 Olympic sized swimming pools!'
        visible={factVisible}
        position='top-left'
      />
      <Button href='https://www.watercorporation.com.au/Our-water/Sustainability-and-innovation/Water-recycling'>
        Learn more about KWRP
      </Button>
    </PanelContent>
  )
}
